import { render, staticRenderFns } from "./AmeliaSettings.vue?vue&type=template&id=4b70568c"
import script from "./AmeliaSettings.vue?vue&type=script&lang=js"
export * from "./AmeliaSettings.vue?vue&type=script&lang=js"
import style0 from "./AmeliaSettings.vue?vue&type=style&index=0&id=4b70568c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports